<template>
    <div id="app">
        <div v-if="isLoading">Loading...</div>
        <template v-else>
            <Navbar
                v-if="$store.getters.isAuthenticated && currentRouteName !== 'login'"
                @localeChange="loadLocaleMessages"></Navbar>
            <router-view />
        </template>
        <ErrorMessage v-if="isLoading === false"/>
    </div>
</template>

<script>
    import { loadLocaleMessagesAsync } from "./i18n";
    import {
        setDocumentDirectionPerLocale,
        setDocumentLang
    } from "./utils/i18n/document";

    import Navbar from "./components/navbar/Navbar";
    import ErrorMessage from "./components/shared/ErrorMessage";

    export default {
        name: 'app',
        components: {
            Navbar,
            ErrorMessage
        },
        data: () => ({
           isLoading: true
        }),
        mounted() {
            this.loadLocaleMessages(this.$i18n.locale);
        },
        computed: {
            currentRouteName() {
                return this.$route.name;
            }
        },
        methods: {
            loadLocaleMessages(locale) {
                this.isLoading = true;
                loadLocaleMessagesAsync(locale).then(() => {
                    setDocumentLang(locale);
                    setDocumentDirectionPerLocale(locale);
                    this.isLoading = false
                });
            }
        }
    }
</script>

<style>
    body {
        min-height: 100vh;
    }
</style>
